import { ProgressBar } from 'primereact/progressbar';
import themeColor from '../../../styles/colors.json';
import styles from '../../components/dialog/loading-blocker.module.css';

const LoadingProgressBar = () => {
	return (
		<ProgressBar
			mode="indeterminate"
			color={themeColor.loadingProgressBar}
			className={styles.progressBar}
		/>
	);
};

export default LoadingProgressBar;
